import classes from "./styles.module.scss";
import { Component } from "react";
import React from "react";
import { MainStore } from "../../../stores/MainStore";
import { observer } from "mobx-react";
import Label from "../../Label";
import VideoPlayer from "../../VideoPlayer";

interface IProps {
  store: MainStore;
}
interface IState {
  videoOut: boolean;
}
@observer
class VideoAnimator extends Component<IProps, IState> {
  state = {
    videoOut: false
  };
  render() {
    const { store } = this.props;
    const { videoOut } = this.state;
    if (!store) return null;
    return (
      <div
        className={[
          classes.VideoAnimator,
          videoOut ? classes.VideoOut : classes.VideoIn
        ].join(" ")}
      >
        <div className={classes.VideoInHeader}>
          <div
            onClick={e => {
              store.openStateDetail(store.selectedState);
              setTimeout(() => {
                this.setState({
                  videoOut: true
                });
              }, 1000);
              setTimeout(() => {
                this.setState(
                  {
                    videoOut: false
                  },
                  () => store.closeVideo()
                );
              }, 3250);
            }}
          >
            <Label uppercase bold medium id={"modal.country.discover"} />
          </div>
        </div>
        <div className={classes.VideInBody}>
          <div className={classes.VideoWrapper}>
            <VideoPlayer store={store} />
          </div>
        </div>
      </div>
    );
  }
}
export default VideoAnimator;
